import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const SeikyuKbn = props => {
  return <Dropdown.Static kubunKey='seikyu_kbn' {...props} />
}
